import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Button from "../Button/Button";
import { useDesignTokens } from "../../../theme/useDesignTokens";

/**
 * Common Dialog Component
 * Provides consistent dialog styling and behavior
 */
const Dialog = ({
  open = false,
  onClose,
  title,
  children,
  actions = [],
  maxWidth = "sm",
  fullWidth = true,
  sx = {},
  disablePortal = false,
  scroll = "paper",
  loading = false,
}) => {
  const { font } = useDesignTokens();

  return (
    <MuiDialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        // onClose();
        if (typeof onClose === "function") {
          onClose(event, reason);
        }
      }}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={sx}
      disablePortal={disablePortal}
      scroll={scroll}
      TransitionProps={{ timeout: 300 }}
      slotProps={{
        backdrop: {
          TransitionProps: { timeout: 300 },
        },
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            fontWeight: font?.weight?.fontW700,
            fontSize: font?.size?.fontSz20,
          }}
        >
          {title}
        </DialogTitle>
      )}
      {children && (
        <DialogContent sx={{ pt: title ? 2 : 3 }}>{children}</DialogContent>
      )}
      {!loading && actions && actions.length > 0 && (
        <DialogActions sx={{ padding: "16px 24px", gap: 1 }}>
          {actions.map((action, index) => (
            <Button
              // key={index}
              key={action.key ?? `${action.label ?? "action"}-${index}`}
              variant={action.variant || "primary"}
              size={action.size || "medium"}
              onClick={action.onClick}
              disabled={action.disabled}
              startIcon={action.startIcon}
              endIcon={action.endIcon}
              loading={action.loading}
              isNotAllowed={action?.isNotAllowed}
              tooltip={action.tooltip}
              slotProps={action.slotProps}
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
